var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.678,
    height: 10.38,
    viewBox: "0 0 11.678 10.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-exclamation-triangle",
    "data-name": "Icon awesome-exclamation-triangle",
    d: "M11.546,8.921A.974.974,0,0,1,10.7,10.38H.974A.974.974,0,0,1,.131,8.921L5,.486a.974.974,0,0,1,1.686,0ZM5.839,7.177a.933.933,0,1,0,.933.933A.933.933,0,0,0,5.839,7.177ZM4.911,3.363,5.1,6.582a.243.243,0,0,0,.243.23h.984a.243.243,0,0,0,.243-.23l.108-3.219a.243.243,0,0,0-.243-.257H5.154a.243.243,0,0,0-.243.257Z",
    fill: "#ef466f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.602e46d03558373711340ac204326ccf.svg";
export { ForwardRef as ReactComponent };